<template>
  <div
    v-if="isAllowed"
    :class="{
      'mini-chat--active': activeMiniChat,
      'mini-chat--open': open
    }"
    :style="right && `right: ${right}px`"
    class="mini-chat">
    <div v-if="activeChat" class="mini-chat__top">
      <template v-for="(member, index) in activeChat.members">
        {{ member.fullName || `${member.firstName} ${member.lastName}` }}<template v-if="index < activeChat.members.length-1">, </template>
      </template>
      <v-spacer />
      <v-btn class="mini-chat__expand" icon small @click="open = !open">
        <v-icon size="32">mdi-chevron-up</v-icon>
      </v-btn>
      <v-btn icon small @click="closeMiniChat">
        <v-icon size="26">$clear</v-icon>
      </v-btn>
    </div>
    <transition name="fade-transition">
      <chat v-if="activeChat && activeMiniChat" :key="activeChat.id" dense />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import permissionCheckMixin from '@/common/mixins/permissionCheckMixin';

import Chat from '@/components/shared/Chat';

export default {
  name: 'MiniChat',
  components: { Chat },
  data() {
    return {
      open: true,
    };
  },
  mixins: [permissionCheckMixin],
  computed: {
    ...mapState('messenger', ['activeChat', 'activeMiniChat']),
    ...mapState('loggedAccount', ['account']),
    right() {
      let right = 40;
      if (this.$vuetify.breakpoint.name === 'sm') right = 30;
      else if (this.$vuetify.breakpoint.name === 'xs') right = 15;
      return right + this.$vuetify.breakpoint.scrollBarWidth;
    },
    isAllowed() {
      return this.checkFeatureAllowance('messaging');
    },
  },
  methods: {
    ...mapMutations('messenger', ['setActiveChat', 'setActiveMiniChat']),
    closeMiniChat() {
      this.setActiveMiniChat(false);
      this.setActiveChat(null);
      this.open = false;
    },
  },
  watch: {
    activeChat(val) {
      if (val && !this.open) this.open = true;
    },
    '$route.name': function (name) {
      if (this.activeMiniChat && ['Messenger', 'Login', 'VideoCall'].includes(name)) this.closeMiniChat();
    },
  },
};
</script>

<style lang="scss">
  @import 'src/assets/style/shared/MiniChat';
</style>
